import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "move",
  "use": "move-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"move\"><path d=\"M0 7a1 1 0 102 0 1 1 0 00-2 0zM0 13a1 1 0 102 0 1 1 0 00-2 0zM0 1a1 1 0 102 0 1 1 0 00-2 0zM6 7a1 1 0 102 0 1 1 0 00-2 0zM6 13a1 1 0 102 0 1 1 0 00-2 0zM6 1a1 1 0 102 0 1 1 0 00-2 0z\" fill=\"#7D7D7D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol